import { SiteEntity } from "@ots-frontend/ots-data";
import { useCallback } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseSiteSelectProps = Omit<
  BaseEntitySelectProps<SiteEntity>,
  'nameMapper'
>;

export const BaseSiteSelect = (props: BaseSiteSelectProps) => {
  const nameMapper = useCallback((e: SiteEntity) => {
    return e.name;
  }, []);

  return <BaseEntitySelect nameMapper={nameMapper} {...props} />;
};
